import axios from "axios";

const host = window.location.hostname;

const isLocalhost =
  host === "localhost" ||
  host === "127.0.0.1";

export const API_BASE = isLocalhost
  ? "http://localhost:2641/api"
  : "https://nalozi.megasoft.com.mk/api";

export const FILE_BASE = isLocalhost
  ? "http://localhost:2641"
  : "https://nalozi.megasoft.com.mk";

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;